import {Event} from "@app/core/tracking/domain/event";

export class OrderCompletedEvent extends Event{
}